// When updating this model also update the copy in '/integration-tests/cypress/models/index.ts'
export type LocalDate = string;
export const localDateFormatString = 'YYYY-MM-DD';
